<div class="w-full my-1 ">
    <div class="grid grid-cols-4 gap-8 mb-8">
        <mat-label class="flex items-center"> Type of Retrievable Valve / Plug </mat-label>
        <mat-form-field class="no-bottom-gap">
            <mat-select placeholder="Select Type" [(ngModel)]="wrsvForm.trsvType" [disabled]="!isLockOpen">
                <mat-option *ngFor="let wrsvType of wrsvTypleList" [value]="wrsvType.name"> {{ wrsvType.name
                    }} </mat-option>
            </mat-select>
        </mat-form-field>

        <div class="col-span-2"></div>

        <mat-label class="flex items-center"> Initial Installed Date </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput [matDatepicker]="initialInstalledpicker" [(ngModel)]="wrsvForm.initialInstalledDate"
                [disabled]="!isLockOpen" />
            <mat-datepicker-toggle matIconSuffix [for]="initialInstalledpicker"></mat-datepicker-toggle>
            <mat-datepicker #initialInstalledpicker></mat-datepicker>
        </mat-form-field>

        <mat-label class="flex items-center"> Part Number </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput placeholder="" [(ngModel)]="wrsvForm.partNo" [disabled]="!isLockOpen">
        </mat-form-field>

        <mat-label class="flex items-center"> Latest Installed Date </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput [matDatepicker]="latestInstalledpicker" [(ngModel)]="wrsvForm.latestInstalledDate"
                [disabled]="true" />
            <mat-datepicker-toggle matIconSuffix [for]="latestInstalledpicker"></mat-datepicker-toggle>
            <mat-datepicker #latestInstalledpicker></mat-datepicker>
        </mat-form-field>

                <mat-label class="flex items-center">Model </mat-label>
        <mat-form-field class="no-bottom-gap">
            <mat-select matNativeControl [(ngModel)]="wrsvForm.model"
                [disabled]="wrsvForm.trsvType != 'Plug' || !isLockOpen">
                <mat-option [value]="'PXX'">PXX</mat-option>
                <mat-option [value]="'PXN'">PXN</mat-option>
                <mat-option [value]="'XXR'">XXR</mat-option>
                <mat-option [value]="'BPV'">BPV</mat-option>
                <mat-option [value]="'Nippless'">Nippless</mat-option>
                <mat-option [value]="'Others'">Others</mat-option>
            </mat-select>
        </mat-form-field>
        
        <mat-label class="flex items-center"> Subsequent Installed Date </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput [matDatepicker]="picker2" [(ngModel)]="wrsvForm.subsequentInstalledDate"
                [disabled]="true" />
            <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>



        <mat-label class="flex items-center">Size </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput placeholder="" type="number" [(ngModel)]="wrsvForm.sizeIn" [disabled]="!isLockOpen">
            <span matTextSuffix>inches</span>
        </mat-form-field>

        <mat-label class="flex items-center">Installation Depth </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput placeholder="" type="number" [(ngModel)]="wrsvForm.installationDepth"
                [disabled]="!isLockOpen">
            <span matTextSuffix>meter</span>
        </mat-form-field>

        <mat-label class="flex items-center">Equipment Brand / OEM </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput placeholder="" [(ngModel)]="wrsvForm.equipmentBrand" [disabled]="!isLockOpen">
        </mat-form-field>

        <mat-label class="flex items-center">Location</mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput placeholder="" [(ngModel)]="wrsvForm.installationAtSvlntrsv" [disabled]="!isLockOpen">
        </mat-form-field>

        <mat-label class="flex items-center">Rating </mat-label>
        <mat-form-field class="no-bottom-gap">
            <input matInput placeholder="" type="number" [(ngModel)]="wrsvForm.ratingPsi" [disabled]="!isLockOpen">
            <span matTextSuffix>psi</span>
        </mat-form-field>

        <mat-label class="flex items-center">Reason/Remarks </mat-label>
        <mat-form-field class="no-bottom-gap col-span-3">
            <input matInput placeholder="" [(ngModel)]="wrsvForm.remark" [disabled]="!isLockOpen">
        </mat-form-field>
    </div>

    <div class="flex justify-end">
        <span *ngIf="!hasTrsssv" class="flex items-end mr-3 font-medium text-gray-400 italic text-md">
            <i> Please insert the TR-SSSV details first before {{ isReplace ? 'saving' : 'updating' }}.</i>

        </span>
        <span *ngIf="!isLockOpen" class="flex items-end mr-3 font-medium text-gray-400 italic text-md">
            <i> The TR-SSSV is not Locked-Open, hence WRSV is Not Applicable.</i>
        </span>
        <button class="btn btn-primary" [disabled]="disabledSave()" (click)="save()"> Save </button>
    </div>
</div>